export const useCostData = () => {
    const fetchOverview = async () => {
        return await $fetch('/api/mocks/cost/overview')
    }

    const fetchTrend = async (timeRange: string = '30d') => {
        return await $fetch(`/api/mocks/cost/trend?range=${timeRange}`)
    }

    const fetchByWarehouse = async () => {
        return await $fetch('/api/mocks/cost/by-warehouse')
    }

    const fetchByUser = async () => {
        return await $fetch('/api/mocks/cost/by-user')
    }

    const fetchAnomalies = async () => {
        return await $fetch('/api/mocks/cost/anomalies')
    }

    const fetchRecommendations = async () => {
        return await $fetch('/api/mocks/cost/recommendations')
    }

    const fetchHeatmap = async () => {
        return await $fetch('/api/mocks/cost/heatmap')
    }

    return {
        fetchOverview,
        fetchTrend,
        fetchByWarehouse,
        fetchByUser,
        fetchAnomalies,
        fetchRecommendations,
        fetchHeatmap
    }
}
